import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(27, 27, 27, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  background: white;
  border-radius: 8px;
  width: 494px;
  max-height: 797px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 0 24px;
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  cursor: pointer;

  span {
    font-family: 'Mangueira', sans-serif;
    font-weight: 500;
    font-style: normal;
    font-size: 16px;
    color: #3D3D3D;
  }

  &:hover {
    opacity: 0.7;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 32px;
  cursor: pointer;
  color: #636363;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.7;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  gap: 24px;
  overflow-y: auto;
  max-height: calc(100vh - 200px);
`;

export const UserIcon = styled.div`
  width: 85px;
  height: 85px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 0;

  img {
    width: 85px;
    height: 85px;
  }
`;

export const HeaderTitle = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-self: stretch;
`;

export const ModalTitle = styled.h2`
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 20px;
  color: #3D3D3D;
  text-align: center;
  margin: 0;
`;

export const ModalSubtitle = styled.p`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #636363;
  margin: 0;
  line-height: 1.542em;
  text-align: center;
`;

export const FeedbackSection = styled.div`
  background: white;
  border: 1px solid #CBCBCB;
  border-radius: 8px;
  padding: 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FeedbackTitle = styled.h3`
  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  font-style: normal;
  font-size: 14px;
  color: #3D3D3D;
  margin: 0 0 16px 0;
  text-align: center;
`;

export const CategoryTitle = styled.h4`
  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: ${props => props.positive ? '#3DA464' : props.negative ? '#BA5A5A' : '#3D3D3D'};
  margin: 0 0 8px 0;
  line-height: 1.542em;
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
`;

export const FeedbackButton = styled.button`
  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 8px;
  border: 1px solid #CBCBCB;
  background: ${props => {
    if (props.others) return props.selected ? '#EDEFFF' : 'white';
    return props.selected ? '#EDEFFF' : 'white';
  }};
  color: #3D3D3D;
  cursor: pointer;
  height: 29px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  ${props => props.others && props.selected && `
    background: #EDEFFF;
  `}
`;

export const CommentsSection = styled.div`
  background: white;
  border: ${props => props.inline ? 'none' : '1px solid #CBCBCB'};
  border-radius: ${props => props.inline ? '0' : '8px'};
  padding: ${props => props.inline ? '16px 0' : '24px'};
  width: 100%;
  height: ${props => props.inline ? 'auto' : 'auto'};
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CommentsTitle = styled.h3`
  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #3D3D3D;
  margin: 0 0 16px 0;
  text-align: center;
`;

export const CommentsContainer = styled.div`
  position: relative;
  overflow: visible;
  margin-bottom: 16px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  height: 129px;
  padding: 12px;
  border: 1px solid #CBCBCB;
  border-radius: 8px;
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #3D3D3D;
  resize: none;
  outline: none;

  &::placeholder {
    color: #CBCBCB;
  }

  &:focus {
    border-color: #0B29FB;
  }
`;

export const CharacterCount = styled.div`
  position: absolute;
  bottom: 12px;
  right: 12px;
  font-family: 'Mangueira', sans-serif;
  font-weight: 500;
  font-size: 13px;
  color: #636363;
  pointer-events: none;
  z-index: 10;
`;

export const Footer = styled.div`
  background: white;
  border-radius: 0 0 8px 8px;
  padding: 24px;
  display: flex;
  justify-content: center;
`;

export const FooterButton = styled.button`
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 16px;
  background: ${props => props.primary ? '#0B29FB' : 'white'};
  color: ${props => props.primary ? 'white' : '#3D3D3D'};
  border: none;
  border-radius: 5px;
  width: 447px;
  height: 40px;
  cursor: pointer;
  text-align: center;
  transition: all 0.2s ease;

  &:hover {
    opacity: ${props => props.disabled ? 0.5 : 0.8};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ValidationMessageError = styled.div`
  font-size: 12px;
  color: #D32F2F;
  margin-bottom: 16px;
`;

export const ValidationMessageInfo = styled.div`
  font-size: 12px;
  color: #999;
  margin-bottom: 16px;
`;
